<!-- Bloque de CTAs -->
<section aria-labelledby="ctas-title" class="bg-transparent">
    <!-- GRID responsiva: 1 / 2 / 4 columnas -->
    <div style="gap: 2px" class="mt-6 grid grid-cols-1 sm:grid-flow-col sm:auto-cols-fr overflow-hidden">
        <ng-container *ngFor="let card of ctaCards; let i = index">
            <article
                *ngIf="!card.disabled && i < 4"
                class="group relative bg-white p-4 min-h-[220px] flex flex-col justify-between transition-all duration-200 ease-out"
                [ngStyle]="{
                    'background-image': hoveredCard === card ? 'url(' + card.hoverImage + ')' : 'none',
                    'background-position': 'center',
                    'background-size': 'cover'
                }"
                (mouseenter)="hoveredCard = card"
                (mouseleave)="hoveredCard = null"
            >
                <!-- Imagen de hover (desactivada en móvil, aparece suave al pasar el mouse) -->
                <!-- <div class="pointer-events-none absolute inset-0 hidden sm:block">
        <div
          class="absolute bottom-0 right-0 h-full w-full opacity-0 translate-x-2 translate-y-2
                 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0
                 transition-all duration-300 ease-out"
          [style.backgroundImage]="'url(' + card.hoverImage + ')'"
          style="background-size: cover; background-position: center;"
        ></div>
      </div> -->
                <!-- Cabecera: icono simple -->
                <div class="flex flex-col">
                    <div class="h-8 w-8">
                        <app-cosentino-svg class="icon" [svgName]="card.svgIcon" [size]="32"></app-cosentino-svg>
                    </div>
                    <span class="mt-3 typography-title-m">
                        {{ card.title | translate }}
                    </span>
                </div>

                <!-- Título -->

                <!-- Botón -->
                <div class="mt-6">
                    <app-button size="L" class="w-full" (click)="card.action?.()">
                        {{ card.buttonText | translate }}
                    </app-button>
                </div>
            </article>
        </ng-container>

        <!-- Estado vacío (por si un rol no trae tarjetas) -->
        <div *ngIf="!ctaCards?.length" class="col-span-full">
            {{ 'home.no_actions_available' | translate }}
        </div>
    </div>
</section>
